'use client'
import type { FC } from 'react'
import styled from 'styled-components'
import { SectionBrandDescription } from './SectionBrandDescription'
import { SectionBrandWarranty } from './SectionBrandWarranty'

export const MainBrandDetail:FC = () => {
  return (
    <Main className='main--root'>
      <SectionBrandDescription />
      <SectionBrandWarranty />
    </Main>
  )
}

const Main = styled.main`
  grid-column: 1;
`
